export default "__VITE_ASSET__96d4c02d__"